import React, { useEffect, useState } from "react";
import { Container, Button, Spinner, Card, Row } from "reactstrap";
import Header from "components/Headers/Header";
import { useDispatch, useSelector } from "react-redux";
import { formatDistanceToNow } from "date-fns";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Tabs from "components/Tabe";
import {
  getNotificationsByStatus,
  updateNotification,
} from "store/actions/notificationAction";
import TabsInfoModal from "components/Modal/TabsInfoModal";
const Notifications = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState("unread");
  const [Loader, setLoader] = useState({
    data: false,
  });
  const infoPoints = [
    "There are two tabs: Read and Unread. In the Unread tab, any requests submitted by athletes or fans—such as City, Sport, IP Contract, Substitute Request, Bid, Contest, School, Collective, School Admin Change, Collective Admin Change, Resolution, Institute, Athlete Issue, Fan Issue, or Organizer—are displayed. The admin reviews and takes appropriate actions on these user requests.",
  ];
  const subPoints = [];
  const infoTitle = "Notifications Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const {
    unreadNotifications,
    readNotifications,
    lastUnreadDoc,
    lastReadDoc,
    hasMoreUnread,
    hasMoreRead,
    isFetchingUnread,
    isFetchingRead,
  } = useSelector((state) => state.notifications);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  const handleUnreadNotifications = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getNotificationsByStatus(false, null, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const handleReadNotifications = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getNotificationsByStatus(true, null, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };

  const getFormattedTime = (createdAt) => {
    if (!createdAt) return "Unknown time";
    const date = new Date(createdAt?.seconds * 1000);
    typeof createdAt === "object" && createdAt.seconds
      ? new Date(createdAt.seconds * 1000)
      : new Date(createdAt);
    return formatDistanceToNow(date, { addSuffix: true });
  };

  const loadMoreUnread = () => {
    if (hasMoreUnread && !isFetchingUnread) {
      dispatch(getNotificationsByStatus(false, lastUnreadDoc));
    }
  };

  const loadMoreRead = () => {
    if (hasMoreRead && !isFetchingRead) {
      dispatch(getNotificationsByStatus(true, lastReadDoc));
    }
  };

  const tabs = [
    {
      id: "unread",
      title: "Unread",
      content: (
        <>
          <div>
            {Loader.data ? (
              <div className="text-center">
                <Spinner color="primary" />
              </div>
            ) : unreadNotifications?.length > 0 ? (
              unreadNotifications.map((notification) => {
                return (
                  <div
                    onClick={() =>
                      handleDelete(notification?.id, notification?.type)
                    }
                    key={notification.id}
                    className="d-flex cursor-pointer justify-content-between align-items-start mb-3 p-3 shadow bg-white rounded border-start"
                  >
                    <div className="d-flex">
                      <img
                        src={
                          notification?.image ||
                          "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                        }
                        alt="user"
                        className="rounded-circle mr-3"
                        style={{ width: "48px", height: "48px" }}
                      />
                      <div>
                        <p className="mb-1">
                          <strong className="text-uppercase">
                            {notification.type || "N/A"}
                          </strong>{" "}
                          request waiting for your response
                        </p>
                        <p className="text-muted mb-0 small">
                          {getFormattedTime(notification?.createdAt)}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="d-flex justify-content-center align-items-center py-10 px-10">
                No Notifications Found!
              </div>
            )}

            {hasMoreUnread && unreadNotifications?.length > 4 && (
              <div className="text-center mt-4">
                <Button
                  onClick={loadMoreUnread}
                  disabled={isFetchingUnread}
                  color="primary"
                >
                  {isFetchingUnread ? <Spinner size="sm" /> : "Load More"}
                </Button>
              </div>
            )}
          </div>
        </>
      ),
      onClick: handleUnreadNotifications,
    },
    {
      id: "read",
      title: "Read",
      content: (
        <>
          <div className="overflow-y-auto">
            {Loader.data ? (
              <div className="text-center">
                <Spinner color="primary" />
              </div>
            ) : readNotifications?.length > 0 ? (
              readNotifications.map((notification) => (
                <div
                  onClick={() =>
                    handleDelete(notification?.id, notification?.type)
                  }
                  key={notification.id}
                  className="d-flex cursor-pointer justify-content-between align-items-start mb-3 p-3 shadow bg-white rounded border-start"
                >
                  <div className="d-flex">
                    <img
                      src={
                        notification?.image ||
                        "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                      }
                      alt="user"
                      className="rounded-circle mr-3"
                      style={{ width: "48px", height: "48px" }}
                    />
                    <div>
                      <p className="mb-1">
                        <strong className="text-uppercase">
                          {notification.type || "N/A"}
                        </strong>{" "}
                        request waiting for your response
                      </p>
                      <p className="text-muted mb-0 small">
                        {getFormattedTime(notification?.createdAt)}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="d-flex justify-content-center align-items-center py-10 px-10">
                No Notifications Found!
              </div>
            )}

            {hasMoreRead && readNotifications?.length > 4 && (
              <div className="text-center mt-4">
                <Button
                  onClick={loadMoreRead}
                  disabled={isFetchingRead}
                  color="primary"
                >
                  {isFetchingRead ? <Spinner size="sm" /> : "Load More"}
                </Button>
              </div>
            )}
          </div>
        </>
      ),
      onClick: handleReadNotifications,
    },
  ];
  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getNotificationsByStatus(false, null, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(
      getNotificationsByStatus(true, null, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);
  const handleDelete = (id, type) => {
    if (type === "school") {
      history.push("/admin/schools");
    } else if (type === "school-admin-change") {
      history.push(`/admin/schools?type='change_school_admin'`);
    } else if (type === "collective-admin-change") {
      history.push(`/admin/collectives?type='change_school_admin'`);
    } else if (type === "IP Contract") {
      history.push(`/admin/contract-requests?type='signedRequests`);
    } else if (type === "athlete-issue" || type === "fan-issue") {
      history.push(`/admin/complaints`);
    } else if (type === "resolution") {
      history.push("/admin/resolution");
    } else if (type === "city") {
      history.push("/admin/request-cities");
    } else if (type === "sport") {
      history.push("/admin/request-sports");
    } else if (type === "contest") {
      history.push("/admin/contest");
    } else if (type === "institute") {
      history.push("/admin/institute-requests");
    } else if (type === "collective") {
      history.push("/admin/collectives");
    } else if (type === "organizer") {
      history.push("/admin/organizers");
    } else if (type === "reset-athlete-summary") {
      history.push("/admin/reset-athlete-summary");
    } else if (type === "vendor") {
      history.push("/admin/vendors");
    } else if (type === "substitute-request") {
      history.push(`/admin/bids?type='substitute-requests'`);
    } else if (type === "bid") {
      history.push("/admin/bids");
    } else {
      history.push("/admin/notifications");
    }
    setTimeout(() => {
      dispatch(updateNotification(id));
    }, 100);
  };
  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>
        {/* <h3 className="mb-3 heading-line">
          Notifications <i className="bi bi-bell text-muted"></i>
        </h3> */}
        <Card className="pb-2 overflow-y-auto">
          <Tabs activeTab={activeTab} toggleTab={toggleTab} tabs={tabs} />
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </>
  );
};

export default Notifications;
